export var Profile = (function () {
    function Profile() {
    }
    return Profile;
}());
